<script setup lang="ts" name="ProfileHeader">
import Avatar from '~/components/Avatar.vue';

const { fullName } = defineProps<{
  fullName: string;
  profileRole: string | null;
}>();
</script>

<template>
  <div class="flex items-center gap-4">
    <Avatar size="lg" :name="fullName" />

    <div
      class="space-y-2 md:flex md:items-center md:justify-center md:space-x-4"
    >
      <p class="text-headline text-secondary-9" data-test="profile-title">
        {{ fullName }}
      </p>

      <div v-if="profileRole" class="max-w-max">
        <p
          class="rounded bg-charcoal-2 p-1 text-xs font-bold uppercase leading-none text-charcoal-8"
        >
          {{ profileRole }}
        </p>
      </div>
    </div>
  </div>
</template>
